import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PeopleIcon from '@mui/icons-material/People';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import StoreIcon from '@mui/icons-material/Store';
import InfoIcon from '@mui/icons-material/Info';
import {
  IconButton,
  Tooltip,
  Paper,
  Typography,
  Grid,
  CircularProgress
} from '@mui/material';

import Title from '../../../../components/Title';
import socket from '../../../../services/socket';


function TodayInfo(props) {
  const classes = props.classes;
  var moment = require('moment-timezone');
  const store_id = props.store_id;
  const fixedHeightPaper = clsx(classes.paper);
  const [date, setDate] = useState(moment.tz("America/Sao_Paulo").format('DD/MM/YYYY'));
  const [time, setTime] = useState(moment.tz("America/Sao_Paulo").format('HH:mm'));
  const [attendance, setAttendance] = useState();
  const [attendanceWeek, setAttendanceWeek] = useState();
  const [attendanceMonth, setAttendanceMonth] = useState();
  const [sales, setSales] = useState();
  const [salesWeek, setSalesWeek] = useState();
  const [salesMonth, setSalesMonth] = useState();
  const [conversion, setConversion] = useState();
  const [conversionWeek, setConversionWeek] = useState();
  const [conversionMonth, setConversionMonth] = useState();
  const [isLoading, setIsLoading] = useState(true);

  function SpanClr(props) {
    let value1 = Number(props.value1)
    let value2 = Number(props.value2)
    var proc = (100 * value1 / value2 - 100).toFixed(1);
    if (value2 === 0) {
      proc = 0
    }
    var clr
    var symb
    if (proc >= 0) {
      clr = "#00aa00"
      symb = "+"
    } else {
      clr = "#bb0000"
      symb = ""
    }
    return (<span style={{ color: clr }}> {symb}{proc}% </span>)
  }

  useEffect(() => {
    function askTodayInfoBasic() {
      socket.emit('/vezo/StoreInfo/askTodayInfoBasic', {
        'store_id': store_id,
      }
        , (data) => { 
          console.log(data); 
        })
    }

    async function loadaskTodayInfoBasic() {
      askTodayInfoBasic()
      socket.on('/vezo/StoreInfo/updateTodayInfoBasic/' + store_id, () => {
        // When the server sends a updatePaperInfo, it asks for newer intel
        askTodayInfoBasic();
      })
      socket.on('/vezo/StoreInfo/TodayInfoBasic/' + store_id, (data) => {

        setAttendance(data.attendances ? data.attendances.toFixed(0) : 0)
        setSales(data.value ? data.value.toFixed(2) : 0)
        setConversion(data.conversion ? data.conversion.toFixed(2) : 0)

        setAttendanceWeek(data.attendancesWeek ? data.attendancesWeek.toFixed(0) : 0)
        setSalesWeek(data.valueWeek ? data.valueWeek.toFixed(2) : 0)
        setConversionWeek(data.conversionWeek ? data.conversionWeek.toFixed(2) : 0)

        setAttendanceMonth(data.attendancesMonth ? data.attendancesMonth.toFixed(0) : 0)
        setSalesMonth(data.valueMonth ? data.valueMonth.toFixed(2) : 0)
        setConversionMonth(data.conversionMonth ? data.conversionMonth.toFixed(2) : 0)

        setIsLoading(false);
        setDate(moment.tz("America/Sao_Paulo").format('DD/MM/YYYY'))
        setTime(moment.tz("America/Sao_Paulo").format('HH:mm'))
      });
      return () => socket.disconnect();
    }
    loadaskTodayInfoBasic();
  }, [store_id, moment]);

  return (
    <React.Fragment>
      <Grid item xs={12} md={12} lg={12}>
        <Title> <StoreIcon /> Acompanhe sua loja em tempo real!</Title>
      </Grid>
      <Grid item xs={12} md={12} lg={12}>
        Atualizado em : {date} às {time}
      </Grid>
      <Grid item xs={12} md={4} lg={4}>
        <Paper className={fixedHeightPaper}>
          <Grid container spacing={3} justifyContent={"center"} direction="row">
            <Grid item xs={12} md={2} lg={1}>
              <Tooltip title="Atendimentos (hoje x mesmo dia da semana passada x mesmo dia do mês passado)!
                    Exemplo: Segunda Terça do mês de novembro x Primeira Terça do mês de Novembro x Segunda terça do mês de Outubro. ">
                <IconButton aria-label="Selecionar" size="large">
                  <InfoIcon />
                </IconButton>
              </Tooltip>
            </Grid>
            <Grid item xs={12} md={10} lg={11}>
              <Title> <PeopleIcon /> Atendimentos</Title>
            </Grid>
          </Grid>
          {isLoading ?
            <div style={{ paddingTop: '10px' }}>
              <CircularProgress />
            </div>
            :
            <Grid container spacing={3} justifyContent={"center"} direction="row">
              <Grid item xs={12} md={2} lg={1}>
                { }
              </Grid>
              <Grid item xs={12} md={10} lg={11}>
                <Typography component="p" variant="h4">
                  {attendance}
                </Typography>
                <Typography color="textSecondary" component="p" variant="h7" sx={{ fontSize: 14 }}>
                  Semana passada: {attendanceWeek} <SpanClr value1={attendance} value2={attendanceWeek} />
                </Typography>
                <Typography color="textSecondary" component="p" variant="h7" sx={{ fontSize: 14 }}>
                  Mês passado: {attendanceMonth} <SpanClr value1={attendance} value2={attendanceMonth} />
                </Typography>
              </Grid>
            </Grid>
          }
        </Paper>
      </Grid>
      <Grid item xs={12} md={4} lg={4}>
        <Paper className={fixedHeightPaper} styles={{ "height": 500 }}>
          <Grid container spacing={3} justifyContent={"center"} direction="row">
            <Grid item xs={12} md={2} lg={1}>
              <Tooltip title="Faturamento (hoje x mesmo dia da semana passada x mesmo dia do mês passado)!
                    Exemplo: Segunda Terça do mês de novembro x Primeira Terça do mês de Novembro x Segunda terça do mês de Outubro. ">
                <IconButton aria-label="Selecionar" size="large">
                  <InfoIcon />
                </IconButton>
              </Tooltip>
            </Grid>
            <Grid item xs={12} md={10} lg={11}>
              <Title> <AttachMoneyIcon /> Faturamento</Title>
            </Grid>
          </Grid>
          {isLoading ?
            <div style={{ paddingTop: '10px' }}>
              <CircularProgress />
            </div>
            :
            <Grid container spacing={3} justifyContent={"center"} direction="row">
              <Grid item xs={12} md={2} lg={1}>
                { }
              </Grid>
              <Grid item xs={12} md={10} lg={11}>
                <Typography component="p" variant="h4">
                  {sales + " R$"}
                </Typography>
                <Typography color="textSecondary" component="p" variant="h7" sx={{ fontSize: 14 }}>
                  Semana passada: {salesWeek} <SpanClr value1={sales} value2={salesWeek} />
                </Typography>
                <Typography color="textSecondary" component="p" variant="h7" sx={{ fontSize: 14 }}>
                  Mês passado: {salesMonth} <SpanClr value1={sales} value2={salesMonth} />
                </Typography>
              </Grid>
            </Grid>
          }
        </Paper>
      </Grid>
      <Grid item xs={12} md={4} lg={4}>
        <Paper className={fixedHeightPaper}>
          <Grid container spacing={3} justifyContent={"center"} direction="row">
            <Grid item xs={12} md={2} lg={1}>
              <Tooltip title="Taxa de conversão (hoje x mesmo dia da semana passada x mesmo dia do mês passado)!
                    Exemplo: Segunda Terça do mês de novembro x Primeira Terça do mês de Novembro x Segunda terça do mês de Outubro.">
                <IconButton aria-label="Selecionar" size="large">
                  <InfoIcon />
                </IconButton>
              </Tooltip>
            </Grid>
            <Grid item xs={12} md={10} lg={11}>
              <Title> <HowToRegIcon /> Taxa de conversão</Title>
            </Grid>
          </Grid>
          {isLoading ?
            <div style={{ paddingTop: '10px' }}>
              <CircularProgress />
            </div>
            :
            <Grid container spacing={3} justifyContent={"center"} direction="row">
              <Grid item xs={12} md={2} lg={1}>
                { }
              </Grid>
              <Grid item xs={12} md={10} lg={11}>
                <Typography component="p" variant="h4">
                  {conversion + "%"}
                </Typography>
                <Typography color="textSecondary" component="p" variant="h7" sx={{ fontSize: 14 }}>
                  Semana passada: {conversionWeek} <SpanClr value1={conversion} value2={conversionWeek} />
                </Typography>
                <Typography color="textSecondary" component="p" variant="h7" sx={{ fontSize: 14 }}>
                  Mês passado: {conversionMonth} <SpanClr value1={conversion} value2={conversionMonth} />
                </Typography>
              </Grid>
            </Grid>
          }
        </Paper>
      </Grid>
    </React.Fragment>
  );
};

export default TodayInfo;